import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import App from './mainApp';
import OpenApp from './openApi/app';

import './i18n';
import "@fontsource/montserrat"; // Defaults to weight 400
import "@fontsource/montserrat/600.css"; // Import specific weight


import * as serviceWorker from './serviceWorker';



if(window && window.location && (window.location.pathname == '/submitForm' || window.location.pathname == '/preview' )){

    ReactDOM.render( <OpenApp/>, document.getElementById('root'));
}else{
  
    ReactDOM.render( <App /> , document.getElementById('root'));
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
